import * as md5 from 'crypto-js/md5';
import * as RSA from 'node-rsa';
import {ConstStatic} from './constStatic';


export const formatDataToUrl = function (data, urlP) {
  if (typeof (data) === 'string') {
    return urlP + '/' + data;
  }
  if (typeof (data) === 'object') {
    let args = '?';
    if (urlP.split('?').length > 1) {
      args = '&';
    }
    let i = 0;
    for (let key in data) {
      i++;
      if (i === Object.keys(data).length) {
        args = args + key + '=' + data[key];
      } else {
        args = args + key + '=' + data[key] + '&';
      }
    }
    return urlP + args;
  }
};

export const getUserInfo = function () {
  let userInfo = getLocalStorage(ConstStatic.USER_INFO);
//   console.log(userInfo);
  if (userInfo) {
    return userInfo;
  }
  return '';
};

export const getAppId = function () {
  let appIds = getUserInfo() ? getUserInfo().x_appIds : '';
  if (appIds) {
    return appIds.split(',')[0];
  } else {
    return '';
  }
};

export const getUserPhoto = function () {
  let userPhoto = getUserInfo() ? getUserInfo().x_photo : '';
  if (userPhoto) {
    return userPhoto;
  }
  return '';
};

export const getUserId = function () {
  let userId = getUserInfo() ? getUserInfo().x_userId : '';
  if (userId) {
    return userId;
  }
  return '';
};

export const getUserName = function () {
  let userName = getUserInfo() ? getUserInfo().x_realName : '';
  if (userName) {
    return userName;
  }
  return '';
};
export const getRoleType = function () {
  let roleType = getUserInfo() ? getUserInfo().roleType : '';
  if (roleType) {
    if (typeof(roleType) === 'string') {
      return Number(roleType);
    }
    return roleType;
  }
  return 1;
};
export const setRoleType = function (roleTypeP) {
  let userInfo = getUserInfo();
  userInfo.roleType = roleTypeP;
  setLocalStorage(ConstStatic.USER_INFO, userInfo);
};
export const getRoleTypeList = function () {
  let roleTypeList = getUserInfo() ? getUserInfo().roleTypeList : '';
  if (roleTypeList) {
    return roleTypeList;
  }
  return 1;
};
export const setRoleTypeList = function (roleTypeListP) {
  let userInfo = getUserInfo();
  userInfo.roleTypeList = roleTypeListP;
  setLocalStorage(ConstStatic.USER_INFO, userInfo);
};
export const getSubjectTeamId = function () {
  let subjectTeamId = getUserInfo() ? getUserInfo().subjectTeamId : '';
  if (subjectTeamId) {
    return subjectTeamId;
  }
  return '';
};
export const getAccount = function () {
  let account = getLocalStorage(ConstStatic.USER_ACCOUNT);
  if (account) {
    return account;
  }
  return '';
};
export const setAccount = function (Account) {
  let userInfo = Account;
  setLocalStorage(ConstStatic.USER_ACCOUNT, userInfo);
};
export const setSubjectTeamId = function (subjectTeamIdP) {
  let userInfo = getUserInfo();
  userInfo.subjectTeamId = subjectTeamIdP;
  setLocalStorage(ConstStatic.USER_INFO, userInfo);
};
export const getDeptCode = function () {
  let deptCode = getUserInfo() ? getUserInfo().x_deptCode : '';
  if (deptCode) {
    return deptCode;
  }
  return '';
};
export const getJti = function () {
  let jti = getUserInfo() ? getUserInfo().jti : '';
  if (jti) {
    return jti;
  }
  return '';
};
export const getDeptName = function () {
  let deptName = getUserInfo() ? getUserInfo().x_deptName : '';
  if (deptName) {
    return deptName;
  }
  return '';
};
export const getProjectId = function () {
  // return 'e5aaec5475ba4b8387eb67062f724dc3';
  return getLocalStorage(ConstStatic.PROJECTID)||'';

};

export const getToken = function getToken() {
  let token = getLocalStorage(ConstStatic.TOKEN_KEY);
  return token;
};


export const getLocalStorage = function (item) {
  let data = window.localStorage.getItem(item);
  let obj = JSON.parse(data);
  if (obj && obj.localStorageitem) {
    obj = obj.localStorageitem;
  }
  return obj;
};


export const setLocalStorage = function (itemName, item) {
  let obj;
  if (!item) {
    return;
  }
  if (typeof item === 'object') {
    obj = JSON.stringify(item); //转化为JSON字符串
  } else {
    obj = JSON.stringify({'localStorageitem': item});
  }
  window.localStorage.setItem(itemName, obj);
  return obj;
};

export const removeLocalStorage = function (itemName) {
  localStorage.removeItem(itemName);
};

export const getRate = function (num1, num2, fixNum) {
  let rate = 0;
  if (num2 != 0) {
    rate = (num1 / num2) * 100;
    let y = String(rate).indexOf('.') + 1;
    if (y > 0) {
      let decimals = rate.toString().split('.')[1].length;
      if (decimals > 1) {
        rate = rate.toFixed(fixNum);
      }
    }
  }
  return rate;
};
export const getSignWithUrl = function (urlp) {
  let appKey = '2ecadzFRwkJ7QguQRG0';
  let appSecret = '045a6d4a3c0c440fb9787891440d525c';
  let timestamp = parseInt(new Date().getTime() / 1000 / 60);
  let sig = md5(appKey + appSecret + timestamp, 'hex').toString();
  let stringSig;
  if (urlp.includes('?')) {
    stringSig = '&appKey=' + appKey + '&timestamp=' + timestamp.toString() + '&sig=' + sig;
  } else {
    stringSig = '?appKey=' + appKey + '&timestamp=' + timestamp.toString() + '&sig=' + sig;
  }
  return urlp + stringSig;
};
export const getRSAString = function (value) {
  const NodeRSA = require('node-rsa');
  const otherKey = new NodeRSA('-----BEGIN PUBLIC KEY-----\n'+
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjaKvPo5od78knfL7bYuUUDvXeAjlO9/P\n' +
  'UqrQPDiPt7YJrh6GRyUAo56ypnCIsWMRUbUUKZnKS/9ASI/EvOC3ivRmAxIJfh0Ox07PZNS4DbLL\n' +
  '+7wmSVk8vogIEpjQ9nF9v1BsK/EyEHNiMi1NsDIAbfblGumJQ7BXZG+tK5DEdk6axgfPexlMk77R\n' +
  '5Jfgj1fvKBiLWbBa+MYJeIRkEWNkshU9GAOIeBiuD5QMsya6MiuB6FC+7d8PNCIU+3QXSvmIagnp\n' +
  'rpa0vVCoq/seetkyQYFa6nEwm6mKUMoOeQm+DezI+jQTnN4erKSrtAZyHgPW7jRi2la2xiCmbM6UcEj7LQIDAQAB\n'+
    '-----END PUBLIC KEY-----');
  otherKey.setOptions({encryptionScheme: 'pkcs1'});//就是增加这一行代码。
  let encrypted = otherKey.encrypt(value, 'base64');
  // encrypted = encodeURIComponent(encrypted);
  return encrypted;

};

export const getUrlQuery = function (variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return (false);
};



// WEBPACK FOOTER //
// ./src/core/appUtils.js